import { action, makeObservable, observable, runInAction } from 'mobx';
import { Maybe } from '../../core';
import { notifyError, notifySuccess } from '../../services/notifications';
import { Store } from '../../store/store';
import { Message, StoreNode } from '../../store';
import { WindowState } from '../overlays/windowState';

export class RemoveJobFromCliprWindowState
  extends StoreNode {

  readonly nodeType = 'RemoveJobFromCliprWindow';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'windowListener'>(this, {
      isLoading: observable,
      submit: action,
      windowListener: action,
      open: action,
      close: action,
    });

    this.window.listen(
      this.windowListener);
  }

  readonly window = new WindowState(this.store);

  isLoading: boolean = false;

  jobId: Maybe<string>;
  teamId: Maybe<string>;

  async submit() {
    this.isLoading = true;

    const [, err] = await this.store.apiService.archiveJob({ id: this.jobId || '' });

    if (err) {
      notifyError(this, 'Could not remove.');
      return this.handleSubmitFinally();
    }

    this.store.bookmarkManager.bookmarkListLookup.clear();
    await this.store.bookmarkManager.apiFetchBookmarkLists();

    runInAction(() => {
      notifySuccess(this, 'Removed from CLIPr.');

      // TODO: remove hard dependencies to other pages
      this.teamId ?
        this.store.teamDashboardPage.mounted({ teamId: this.teamId }) :
        this.store.userDashboardPage.mounted({});

      this.handleSubmitFinally();
      this.emit('JobRemoved')
    });
  }

  handleSubmitFinally() {
    runInAction(() => {
      this.isLoading = false;
      this.close();
    })
  }

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  open({ jobId, teamId }: { jobId: string, teamId?: string }) {
    this.dispatch('Overlays', 'openWindow', { name: 'RemoveJobFromCliprWindow' });

    this.jobId = jobId;
    this.teamId = teamId;
  }

  close() {
    this.jobId = null;

    this.emit('close');
    this.dispatch('Overlays', 'closeWindow');
  }
}